'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@achra/ui/badge';
import { cn } from '@achra/ui/lib/utils';
import { Check } from 'lucide-react';
import type { PersonaOption } from '@/modules/onboarding/lib/personas';
interface PersonaCardProps {
  persona: PersonaOption;
  selected: boolean;
  onSelect: () => void;
  disabled?: boolean;
}
function PersonaCard(t0) {
  const $ = _c(35);
  const {
    persona,
    selected,
    onSelect,
    disabled
  } = t0;
  const Icon = persona.icon;
  const isDisabled = persona.disabled === true || disabled === true;
  const t1 = isDisabled ? undefined : onSelect;
  const t2 = !isDisabled && "hover:border-ring/60 cursor-pointer hover:-translate-y-0.5";
  const t3 = selected && "border-primary ring-primary/30 ring-[3px]";
  const t4 = isDisabled && "cursor-not-allowed opacity-55";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = cn("group bg-card text-card-foreground relative flex flex-col gap-3 rounded-xl border p-5 text-left shadow-sm transition-all", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] focus-visible:outline-none", t2, t3, t4);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== persona.iconClassName) {
    t6 = cn("flex size-10 items-center justify-center rounded-lg", persona.iconClassName);
    $[4] = persona.iconClassName;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== Icon) {
    t7 = <Icon className="size-5" aria-hidden="true" />;
    $[6] = Icon;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== persona.disabled || $[12] !== persona.disabledLabel || $[13] !== selected) {
    t9 = persona.disabled && persona.disabledLabel ? <Badge variant="secondary" className="text-[10px] tracking-wider uppercase">{persona.disabledLabel}</Badge> : <span aria-hidden="true" className={cn("flex size-5 items-center justify-center rounded-full border transition-colors", selected ? "border-primary bg-primary text-primary-foreground" : "border-input bg-background")}>{selected ? <Check className="size-3" /> : null}</span>;
    $[11] = persona.disabled;
    $[12] = persona.disabledLabel;
    $[13] = selected;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <div className="flex items-start justify-between gap-3">{t8}{t9}</div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== persona.title) {
    t11 = <div className="text-base font-semibold">{persona.title}</div>;
    $[18] = persona.title;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== persona.description) {
    t12 = <p className="text-muted-foreground text-sm leading-snug">{persona.description}</p>;
    $[20] = persona.description;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <div className="flex flex-col gap-1.5">{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== persona.meta) {
    t14 = <div className="text-muted-foreground mt-auto text-xs">{persona.meta}</div>;
    $[25] = persona.meta;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== isDisabled || $[28] !== selected || $[29] !== t1 || $[30] !== t10 || $[31] !== t13 || $[32] !== t14 || $[33] !== t5) {
    t15 = <button type="button" role="radio" aria-checked={selected} aria-disabled={isDisabled} disabled={isDisabled} onClick={t1} className={t5}>{t10}{t13}{t14}</button>;
    $[27] = isDisabled;
    $[28] = selected;
    $[29] = t1;
    $[30] = t10;
    $[31] = t13;
    $[32] = t14;
    $[33] = t5;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}
export { PersonaCard };